/**
 * Calculate appropriate strike interval based on stock price
 * Based on real options market conventions
 */
export function getStrikeInterval(stockPrice) {
  if (stockPrice < 10) {
    return 0.5; // $0.50 intervals for stocks under $10
  } else if (stockPrice < 25) {
    return 1.0; // $1 intervals for stocks $10-$25
  } else if (stockPrice < 100) {
    return 1; // $2.50 intervals for stocks $25-$100
  } else if (stockPrice < 200) {
    return 5.0; // $5 intervals for stocks $100-$200
  } else {
    return 10.0; // $10 intervals for stocks $200+
  }
}

/**
 * Round a price to the nearest valid strike price
 */
export function roundToStrike(price, interval) {
  return Math.round(price / interval) * interval;
}

/**
 * Generate array of strike prices
 * @param {number} stockPrice - Current stock price
 * @param {number} strikesBelow - Number of strikes below current price
 * @param {number} strikesAbove - Number of strikes above current price
 * @returns {number[]} - Array of strike prices
 */
export function generateStrikes(
  stockPrice,
  strikesBelow = 5,
  strikesAbove = 10
) {
  const interval = getStrikeInterval(stockPrice);
  const atmStrike = roundToStrike(stockPrice, interval);

  const strikes = [];

  // Add strikes below ATM
  for (let i = strikesBelow; i > 0; i--) {
    strikes.push(atmStrike - i * interval);
  }

  // Add ATM strike
  strikes.push(atmStrike);

  // Add strikes above ATM
  for (let i = 1; i <= strikesAbove; i++) {
    strikes.push(atmStrike + i * interval);
  }

  // Filter out negative strikes and round to 2 decimals
  return strikes
    .filter((strike) => strike > 0)
    .map((strike) => Math.round(strike * 100) / 100);
}
